// 后端 sys_menu.component 里存的是相对 views/ 的路径,例如 "productMgmt/ProductTab"
// (不带 .vue 后缀)。这里用 webpack 的 require.context 把 src/views 目录下所有 .vue 文件
// 打成一张 { <relative-path-without-ext>: () => import() } 的表,addRoute 时按 component
// 字段去表里查。这样有三个好处:
//   1) webpack 编译期就知道候选文件,能给每个页面切独立 chunk (lazy 模式)
//   2) 后端下发不存在的 component,前端能立刻检测出并跳过 (而不是运行时才 404)
//   3) 新建页面 = 加 .vue 文件,前端零改动,后端 sys_menu 加一行即可

const modules = require.context("@/views", true, /\.vue$/, "lazy");

const loaderMap = {};
modules.keys().forEach((key) => {
  // key 形如 './productMgmt/ProductTab.vue'
  const normalized = key.replace(/^\.\//, "").replace(/\.vue$/, "");
  loaderMap[normalized] = () => modules(key);
});

export function resolveComponent(component) {
  if (!component) return null;
  const loader = loaderMap[component];
  if (!loader) {
    // 后端下发了前端没有的组件路径 — 极可能是拼写错误或新版前端没部署。
    console.warn("[router] unknown component:", component);
  }
  return loader;
}

export function knownComponents() {
  return Object.keys(loaderMap);
}
